/**
 * @generated SignedSource<<74b73161abbeb0c02f33b93e69f09129>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Oauth2Provider = "GITHUB" | "GOOGLE";
import { FragmentRefs } from "relay-runtime";
export type Oauth2LoginButtonsFragment$data = {
  readonly oauth2Providers: ReadonlyArray<Oauth2Provider>;
  readonly " $fragmentType": "Oauth2LoginButtonsFragment";
};
export type Oauth2LoginButtonsFragment$key = {
  readonly " $data"?: Oauth2LoginButtonsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"Oauth2LoginButtonsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Oauth2LoginButtonsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oauth2Providers",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d31e9bf74f32263afd8a9137617e2929";

export default node;
